// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonStyles_fullWidth__1rJzd{
    width:100%
}

.CommonStyles_deleteButton__7jZ1N {
    background-color: rgb(238, 132, 132, 0.2);
    border: 0px;
    color: red; /* Text color */
}
.CommonStyles_deleteButtonNoBackground__3JSTF {
    background-color: #f9fafb;
    border: 0px;
    color: red; /* Text color */
}
.CommonStyles_editButton__ryC7U {
    background-color: rgb(123, 123, 243, 0.2);
    border: 0px;
    color: blue; /* Text color */
}
.CommonStyles_addButton__zRvfx {
    background-color: rgb(3, 192, 74, 0.2);
    border: 0px;
    color: #03C04A; /* Text color */
}
.CommonStyles_closeButton__uJHnd {
    background-color: rgb(100, 116, 139, 0.2);
    border: 0px;
    color: #64748B /* Text color */
}

.CommonStyles_noStyleButton__r3w6U{
    padding-left: 0;
    padding-right: 0;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

.CommonStyles_successTag__6YttJ {
    background-color: rgb(3, 192, 74, 0.2);
    border: 0px;
    color: #03C04A; /* Text color */
}
.CommonStyles_warningTag__\\+NbMk {
    background-color: rgb(249, 115, 22, 0.2);
    border: 0px;
    color: #f97316; /* Text color */ 
}
.CommonStyles_deletedTag__UR\\+lR {
    background-color: rgb(239, 68, 68, 0.2);
    border: 0px;
    color: #EF4444; /* Text color */  
}
.CommonStyles_infoTag__8LRcO {
    background-color: rgb(123, 123, 243, 0.2);
    border: 0px;
    color: blue; /* Text color */
}

.CommonStyles_dialogSubmit__RKH9b{
    align-self: flex-end;
    margin-top: auto;
}

.CommonStyles_dialogFormInput__Z0hme {
    margin-top: 2rem;
}

.CommonStyles_dialogFormInputFirst__hk6z5 {
    padding-top: 5px;
    margin-top: 2rem;
}

.CommonStyles_errorSmall__yA\\+vq {
    padding-left: 5px;
    color: red
}

.CommonStyles_pseudoFloatLabel__cMSXp {
    color: #6b7280;
    font-size: 12px;
}

.CommonStyles_smallButton__EPy\\+B {
    font-size: 0.75rem; /* Adjust the font size as needed */
}

.CommonStyles_selectSpan__rcHE4{
    padding: 0;
    width: 50%;
}

.CommonStyles_currencySpan__0iEbQ {
    padding: 0.1rem;
    width: 25%;
}

.CommonStyles_currencyDropDown__XR9Mk{
    border: 0;
    padding: 0.1rem;
}

.CommonStyles_currencyDropDown__XR9Mk span {
    font-size: 0.8rem;
}

.CommonStyles_currencyDropDown__XR9Mk div {
    font-size: 2rem;
    width:40%
}

.CommonStyles_currencyDropDown__XR9Mk svg{
    width: 12px;
    height: 12px
}

.CommonStyles_leftMenu__TQ3Bi {
    padding-left: 3rem !important;
}

.CommonStyles_mobileActDetailsMenu__51V3c {
    width: 95%
}

.CommonStyles_formInput__SmmwX {
    margin-top: 2rem;
    margin-bottom: 10px;
}

.CommonStyles_nomargin__UyNGz {
    margin: 0
}

.CommonStyles_marginBottom__dLtHD{
    margin-top: 0;
    margin-bottom: 1rem;
}

.CommonStyles_radioButtonBlock__4zblO {
    margin-top: 20px;
    margin-bottom: 25px;
}

.CommonStyles_radioButtonBlockWithMarginLeft__\\+g6kU {
    margin-top: 20px;
    margin-bottom: 25px;
    margin-left: 10px;
}

.CommonStyles_accountingRadio__8OawM {
    margin: 3px;
}

.CommonStyles_active-menu-item__x0YX9 {
    background-color: rgb(123, 123, 243, 0.2);
    color: blue; /* Text color */
    font-weight: bold;
    border-radius: 10%;
}

.CommonStyles_inputfields__\\+d44Z {
    margin-top: 2rem;
    margin-left: 11px;
}

.CommonStyles_inputfieldswomargintop__shh1z {
    margin-left: 10px;
}

.CommonStyles_dialogSubmit__RKH9b{
    align-self: flex-end;
    margin-top: auto;
}

.CommonStyles_smallInput__eyODV {
    max-width: 40px; /* Adjust width as needed */
    height: 15px; /* Adjust height as needed */
    font-size: 12px; /* Make font smaller */
    padding: 2px 4px; /* Adjust padding for a compact look */
}

/* Override focus state */
.CommonStyles_smallInput__eyODV.CommonStyles_p-inputtext__hwAsV {
    font-size: 12px;
    padding: 2px 4px;
    height: 15px;
}

.CommonStyles_smallInput__eyODV .CommonStyles_p-inputtext__hwAsV:focus {
    outline: none; /* Prevent extra focus styling */
    box-shadow: none; /* Remove default focus box-shadow */
    border-color: #ccc; /* Optional: Keep border subtle */
}

/* Handle focus styles for InputNumber */
.CommonStyles_smallInput__eyODV.CommonStyles_p-inputnumber-focused__J93m\\+ {
    box-shadow: none !important; /* Remove box shadow on focus */
    border-color: #ccc; /* Match border color */
}

.CommonStyles_statusCircle__VCTsm {
    width: 0.5cm;
    height: 0.5cm;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.CommonStyles_statusCircleSmall__fMyUw {
    width: 0.25cm;
    height: 0.25cm;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.CommonStyles_statusCircle__VCTsm.CommonStyles_active__SsXlU {
    background-color: #3ee77f;
    box-shadow: 0 0 15px rgba(80, 252, 80, 0.5);
}

.CommonStyles_statusCircle__VCTsm.CommonStyles_pending__hBsBD {
    background-color:  rgb(121, 121, 248);
    box-shadow: 0 0 15px rgba(40, 36, 252, 0.5);
}

.CommonStyles_statusCircle__VCTsm.CommonStyles_inactive__d4nGM {
    background-color: #f06c6c;
    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);
}

.CommonStyles_statusCircleSmall__fMyUw.CommonStyles_active__SsXlU {
    background-color: #3ee77f;
    box-shadow: 0 0 15px rgba(80, 252, 80, 0.5);
}

.CommonStyles_statusCircleSmall__fMyUw.CommonStyles_pending__hBsBD {
    background-color:  rgb(121, 121, 248);
    box-shadow: 0 0 15px rgba(40, 36, 252, 0.5);
}

.CommonStyles_statusCircleSmall__fMyUw.CommonStyles_inactive__d4nGM {
    background-color: #f06c6c;
    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);
}

.CommonStyles_blankButton__JDXFi {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: inherit;  /* Retain text color */
}

.CommonStyles_listWithButton__z4Bui {
    display: flex;
    align-items: center;
}

.CommonStyles_sideBarButton__jzqm1{
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 10px;
}

.CommonStyles_tableStyle__XtI\\+a {
    padding-top: 10px;
}

.CommonStyles_addButtonNav__ZDWrR {
    margin-top: 1rem;
    margin-right: 3px;
    margin-left: 10px;
}

.CommonStyles_headerContainer__AiZrj {
    display: flex;
    align-items: center; /* Centers items vertically */
    justify-content: flex-end;
}

.CommonStyles_footerContainer__q3dHx {
    display: flex;
    align-items: center; /* Centers items vertically */
    justify-content: flex-end;
}

.CommonStyles_footerContainer__q3dHx h3{
    padding-right: 1rem;
}

.CommonStyles_headerContainer__AiZrj span{
    padding-left: 8px;
    padding-right: 1rem;
}

.CommonStyles_portraitdiv__bozKt {
    display: grid;
    justify-content: center;
}
.CommonStyles_portrait__J185z{
    width: 20rem;
}

.CommonStyles_orgContent__jVQDF {
    padding-top: 6rem;
}

.CommonStyles_checkboxStyle__JmI43 label{
    margin-left: .5rem;
}

.CommonStyles_sidebar__B8-yL {
    position: fixed; /* Ensure sidebars are fixed on the screen */
    top: 0;
    bottom: 0;
    height: 100%;
    transition: transform 0.3s ease-in-out;
    z-index: 1000; /* Ensure it appears above other content */
  }
  
  .CommonStyles_shortSideBar__s\\+xB3 {
    width: 300px;
    right: 0; 
  }
  
  .CommonStyles_moveLeft__vKvXl {
    transform: translateX(-300px);
  }

  .CommonStyles_shortMoveLeft__k3Nbd {
    transform: translateX(-150px);
  }
  
  .CommonStyles_secondSidebarActive__VDTuZ {
    transform: translateX(0);
  }
  
  /* Adjustments for larger screens */
  @media (min-width: 768px) {
    .CommonStyles_sidebar__B8-yL {
      width: 300px; /* Same width as defined for both sidebars */
    }
  }

.CommonStyles_sideBarInput__\\+MnE4{
    width:100%;
    margin-top: 2rem;
    margin-bottom: 10px;
}
.CommonStyles_requiredAsterisk__q\\+9o\\+ {
    color: red;
    margin-left: 4px;
}

.CommonStyles_checkBoxInput__H2wC3 {
    margin-top: 1rem;
}

.CommonStyles_inputTextStyle__yjcHv {
    width: 100%;
}

.CommonStyles_paymentSidebar__TK-cG {
    width: 100%;
}

.CommonStyles_productImageWrapper__MnXhK{
    width: 110px;          /* fixed width */
    height: 110px;         /* fixed height */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.CommonStyles_previewImageWrapper__a7j3d{
    width: 200px;          /* fixed width */
    height: 200px;         /* fixed height */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.CommonStyles_productImage__PxNL7 {
    width: 100%;
    height: 100%;
    object-fit: contain;  /* or cover (see below) */
}

@media (max-width: 768px) {
    .CommonStyles_productImageWrapper__MnXhK {
        width: 75px;
        height: 75px;
    }
}
  
  @media (min-width: 576px) {
    .CommonStyles_sidebar__B8-yL {
      width: 75%;
    }
    .CommonStyles_shotrsidebar__1O8gZ {
        width: 75%;
      }
    .CommonStyles_sidebarTable__UlqS9 {
        width:75%
    }
    .CommonStyles_formInput__SmmwX{
        width: 90%
    }
    .CommonStyles_paymentSidebar__TK-cG{
        width: 100%;
    }
    .CommonStyles_pageSideBar__sxTwl {
        width: 100%
    }
    .CommonStyles_moveLeft__vKvXl {
        transform: translateX(-100%);
    }
    .CommonStyles_shortMoveLeft__k3Nbd {
    transform: translateX(-100%);
    }
  }
  
  @media (min-width: 768px) {
    .CommonStyles_sidebar__B8-yL {
      width: 66.67%;
    }
    .CommonStyles_shortSideBar__s\\+xB3{
        width: 50%;
    }
    .CommonStyles_sidebarTable__UlqS9 {
        width:75%
    }
    .CommonStyles_formInput__SmmwX{
        width: 90%
    }
    .CommonStyles_paymentSidebar__TK-cG{
        width: 75%;
    }
    .CommonStyles_pageSideBar__sxTwl {
        width: 100%
    }
    .CommonStyles_moveLeft__vKvXl {
        transform: translateX(-80%);
    }
    .CommonStyles_shortMoveLeft__k3Nbd {
    transform: translateX(-70%);
    }
  }
  
  @media (min-width: 992px) {
    .CommonStyles_sidebar__B8-yL {
      width: 50%;
    }
    .CommonStyles_shortSideBar__s\\+xB3{
        width: 50%;
    }
    .CommonStyles_sidebarTable__UlqS9 {
        width:50%
    }
    .CommonStyles_formInput__SmmwX{
        width: 90%
    }
    .CommonStyles_pageSideBar__sxTwl {
        width: 100%
    }
    .CommonStyles_paymentSidebar__TK-cG{
        width: 50%;
    }
    .CommonStyles_moveLeft__vKvXl {
        transform: translateX(-80%);
    }
    .CommonStyles_shortMoveLeft__k3Nbd {
    transform: translateX(-70%);
    }
    .CommonStyles_currencySpan__0iEbQ {
        padding: 0;
        width: 60%;
    }
  }

  @media (min-width: 1200px) {
    .CommonStyles_sidebar__B8-yL {
      width: 33.33%;
    }
    .CommonStyles_shortSideBar__s\\+xB3{
        width: 30%;
    }
    .CommonStyles_sidebarTable__UlqS9 {
        width:50%
    }
    .CommonStyles_formInput__SmmwX{
        width: 80%
    }
    .CommonStyles_pageSideBar__sxTwl {
        width: 83%
    }
    .CommonStyles_paymentSidebar__TK-cG{
        width: 25%;
    }
    .CommonStyles_moveLeft__vKvXl {
        transform: translateX(-70%);
    }
    .CommonStyles_shortMoveLeft__k3Nbd {
    transform: translateX(-50%);
    }
    .CommonStyles_currencySpan__0iEbQ {
        padding: 0;
        width: 50%;
    }
  }
 
  @media (min-width: 1700px) {
    .CommonStyles_sidebar__B8-yL {
      width: 33.33%;
    }
    .CommonStyles_shortSideBar__s\\+xB3{
        width: 25%;
    }
    .CommonStyles_sidebarTable__UlqS9 {
        width:50%
    }
    .CommonStyles_formInput__SmmwX{
        width: 80%
    }
    .CommonStyles_pageSideBar__sxTwl {
        width: 83%
    }
    .CommonStyles_paymentSidebar__TK-cG{
        width: 20%;
    }
    .CommonStyles_moveLeft__vKvXl {
        transform: translateX(-65%);
    }
    .CommonStyles_shortMoveLeft__k3Nbd {
    transform: translateX(-45%);
    }
    .CommonStyles_currencySpan__0iEbQ {
        padding: 0;
        width: 35%;
    }
  }

  @media (min-width: 2560px) {
    .CommonStyles_paymentSidebar__TK-cG{
        width: 15%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/content/CommonStyles.module.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,UAAU,EAAE,eAAe;AAC/B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,UAAU,EAAE,eAAe;AAC/B;AACA;IACI,yCAAyC;IACzC,WAAW;IACX,WAAW,EAAE,eAAe;AAChC;AACA;IACI,sCAAsC;IACtC,WAAW;IACX,cAAc,EAAE,eAAe;AACnC;AACA;IACI,yCAAyC;IACzC,WAAW;IACX,aAAa,EAAE,eAAe;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,cAAc,EAAE,eAAe;AACnC;AACA;IACI,wCAAwC;IACxC,WAAW;IACX,cAAc,EAAE,eAAe;AACnC;AACA;IACI,uCAAuC;IACvC,WAAW;IACX,cAAc,EAAE,eAAe;AACnC;AACA;IACI,yCAAyC;IACzC,WAAW;IACX,WAAW,EAAE,eAAe;AAChC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB,EAAE,mCAAmC;AAC3D;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,WAAW,EAAE,eAAe;IAC5B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe,EAAE,2BAA2B;IAC5C,YAAY,EAAE,4BAA4B;IAC1C,eAAe,EAAE,sBAAsB;IACvC,gBAAgB,EAAE,sCAAsC;AAC5D;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa,EAAE,gCAAgC;IAC/C,gBAAgB,EAAE,oCAAoC;IACtD,kBAAkB,EAAE,iCAAiC;AACzD;;AAEA,wCAAwC;AACxC;IACI,2BAA2B,EAAE,+BAA+B;IAC5D,kBAAkB,EAAE,uBAAuB;AAC/C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uCAAuC;IACvC,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc,GAAG,sBAAsB;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,6BAA6B;IAClD,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,6BAA6B;IAClD,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe,EAAE,4CAA4C;IAC7D,MAAM;IACN,SAAS;IACT,YAAY;IACZ,sCAAsC;IACtC,aAAa,EAAE,0CAA0C;EAC3D;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,mCAAmC;EACnC;IACE;MACE,YAAY,EAAE,4CAA4C;IAC5D;EACF;;AAEF;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY,WAAW,gBAAgB;IACvC,aAAa,UAAU,iBAAiB;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY,WAAW,gBAAgB;IACvC,aAAa,UAAU,iBAAiB;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB,GAAG,yBAAyB;AACnD;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;EAEE;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;MACZ;IACF;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,WAAW;IACf;IACA;QACI;IACJ;IACA;QACI,4BAA4B;IAChC;IACA;IACA,4BAA4B;IAC5B;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;QACI,UAAU;IACd;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,UAAU;IACd;IACA;QACI;IACJ;IACA;QACI,2BAA2B;IAC/B;IACA;IACA,2BAA2B;IAC3B;EACF;;EAEA;IACE;MACE,UAAU;IACZ;IACA;QACI,UAAU;IACd;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,UAAU;IACd;IACA;QACI,2BAA2B;IAC/B;IACA;IACA,2BAA2B;IAC3B;IACA;QACI,UAAU;QACV,UAAU;IACd;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;QACI,UAAU;IACd;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,UAAU;IACd;IACA;QACI,2BAA2B;IAC/B;IACA;IACA,2BAA2B;IAC3B;IACA;QACI,UAAU;QACV,UAAU;IACd;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;QACI,UAAU;IACd;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI,UAAU;IACd;IACA;QACI,2BAA2B;IAC/B;IACA;IACA,2BAA2B;IAC3B;IACA;QACI,UAAU;QACV,UAAU;IACd;EACF;;EAEA;IACE;QACI,UAAU;IACd;EACF","sourcesContent":[".fullWidth{\n    width:100%\n}\n\n.deleteButton {\n    background-color: rgb(238, 132, 132, 0.2);\n    border: 0px;\n    color: red; /* Text color */\n}\n.deleteButtonNoBackground {\n    background-color: #f9fafb;\n    border: 0px;\n    color: red; /* Text color */\n}\n.editButton {\n    background-color: rgb(123, 123, 243, 0.2);\n    border: 0px;\n    color: blue; /* Text color */\n}\n.addButton {\n    background-color: rgb(3, 192, 74, 0.2);\n    border: 0px;\n    color: #03C04A; /* Text color */\n}\n.closeButton {\n    background-color: rgb(100, 116, 139, 0.2);\n    border: 0px;\n    color: #64748B /* Text color */\n}\n\n.noStyleButton{\n    padding-left: 0;\n    padding-right: 0;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.successTag {\n    background-color: rgb(3, 192, 74, 0.2);\n    border: 0px;\n    color: #03C04A; /* Text color */\n}\n.warningTag {\n    background-color: rgb(249, 115, 22, 0.2);\n    border: 0px;\n    color: #f97316; /* Text color */ \n}\n.deletedTag {\n    background-color: rgb(239, 68, 68, 0.2);\n    border: 0px;\n    color: #EF4444; /* Text color */  \n}\n.infoTag {\n    background-color: rgb(123, 123, 243, 0.2);\n    border: 0px;\n    color: blue; /* Text color */\n}\n\n.dialogSubmit{\n    align-self: flex-end;\n    margin-top: auto;\n}\n\n.dialogFormInput {\n    margin-top: 2rem;\n}\n\n.dialogFormInputFirst {\n    padding-top: 5px;\n    margin-top: 2rem;\n}\n\n.errorSmall {\n    padding-left: 5px;\n    color: red\n}\n\n.pseudoFloatLabel {\n    color: #6b7280;\n    font-size: 12px;\n}\n\n.smallButton {\n    font-size: 0.75rem; /* Adjust the font size as needed */\n}\n\n.selectSpan{\n    padding: 0;\n    width: 50%;\n}\n\n.currencySpan {\n    padding: 0.1rem;\n    width: 25%;\n}\n\n.currencyDropDown{\n    border: 0;\n    padding: 0.1rem;\n}\n\n.currencyDropDown span {\n    font-size: 0.8rem;\n}\n\n.currencyDropDown div {\n    font-size: 2rem;\n    width:40%\n}\n\n.currencyDropDown svg{\n    width: 12px;\n    height: 12px\n}\n\n.leftMenu {\n    padding-left: 3rem !important;\n}\n\n.mobileActDetailsMenu {\n    width: 95%\n}\n\n.formInput {\n    margin-top: 2rem;\n    margin-bottom: 10px;\n}\n\n.nomargin {\n    margin: 0\n}\n\n.marginBottom{\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\n.radioButtonBlock {\n    margin-top: 20px;\n    margin-bottom: 25px;\n}\n\n.radioButtonBlockWithMarginLeft {\n    margin-top: 20px;\n    margin-bottom: 25px;\n    margin-left: 10px;\n}\n\n.accountingRadio {\n    margin: 3px;\n}\n\n.active-menu-item {\n    background-color: rgb(123, 123, 243, 0.2);\n    color: blue; /* Text color */\n    font-weight: bold;\n    border-radius: 10%;\n}\n\n.inputfields {\n    margin-top: 2rem;\n    margin-left: 11px;\n}\n\n.inputfieldswomargintop {\n    margin-left: 10px;\n}\n\n.dialogSubmit{\n    align-self: flex-end;\n    margin-top: auto;\n}\n\n.smallInput {\n    max-width: 40px; /* Adjust width as needed */\n    height: 15px; /* Adjust height as needed */\n    font-size: 12px; /* Make font smaller */\n    padding: 2px 4px; /* Adjust padding for a compact look */\n}\n\n/* Override focus state */\n.smallInput.p-inputtext {\n    font-size: 12px;\n    padding: 2px 4px;\n    height: 15px;\n}\n\n.smallInput .p-inputtext:focus {\n    outline: none; /* Prevent extra focus styling */\n    box-shadow: none; /* Remove default focus box-shadow */\n    border-color: #ccc; /* Optional: Keep border subtle */\n}\n\n/* Handle focus styles for InputNumber */\n.smallInput.p-inputnumber-focused {\n    box-shadow: none !important; /* Remove box shadow on focus */\n    border-color: #ccc; /* Match border color */\n}\n\n.statusCircle {\n    width: 0.5cm;\n    height: 0.5cm;\n    border-radius: 50%;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.statusCircleSmall {\n    width: 0.25cm;\n    height: 0.25cm;\n    border-radius: 50%;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.statusCircle.active {\n    background-color: #3ee77f;\n    box-shadow: 0 0 15px rgba(80, 252, 80, 0.5);\n}\n\n.statusCircle.pending {\n    background-color:  rgb(121, 121, 248);\n    box-shadow: 0 0 15px rgba(40, 36, 252, 0.5);\n}\n\n.statusCircle.inactive {\n    background-color: #f06c6c;\n    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);\n}\n\n.statusCircleSmall.active {\n    background-color: #3ee77f;\n    box-shadow: 0 0 15px rgba(80, 252, 80, 0.5);\n}\n\n.statusCircleSmall.pending {\n    background-color:  rgb(121, 121, 248);\n    box-shadow: 0 0 15px rgba(40, 36, 252, 0.5);\n}\n\n.statusCircleSmall.inactive {\n    background-color: #f06c6c;\n    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);\n}\n\n.blankButton {\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    color: inherit;  /* Retain text color */\n}\n\n.listWithButton {\n    display: flex;\n    align-items: center;\n}\n\n.sideBarButton{\n    width: 100%;\n    margin-top: 2rem;\n    margin-bottom: 10px;\n}\n\n.tableStyle {\n    padding-top: 10px;\n}\n\n.addButtonNav {\n    margin-top: 1rem;\n    margin-right: 3px;\n    margin-left: 10px;\n}\n\n.headerContainer {\n    display: flex;\n    align-items: center; /* Centers items vertically */\n    justify-content: flex-end;\n}\n\n.footerContainer {\n    display: flex;\n    align-items: center; /* Centers items vertically */\n    justify-content: flex-end;\n}\n\n.footerContainer h3{\n    padding-right: 1rem;\n}\n\n.headerContainer span{\n    padding-left: 8px;\n    padding-right: 1rem;\n}\n\n.portraitdiv {\n    display: grid;\n    justify-content: center;\n}\n.portrait{\n    width: 20rem;\n}\n\n.orgContent {\n    padding-top: 6rem;\n}\n\n.checkboxStyle label{\n    margin-left: .5rem;\n}\n\n.sidebar {\n    position: fixed; /* Ensure sidebars are fixed on the screen */\n    top: 0;\n    bottom: 0;\n    height: 100%;\n    transition: transform 0.3s ease-in-out;\n    z-index: 1000; /* Ensure it appears above other content */\n  }\n  \n  .shortSideBar {\n    width: 300px;\n    right: 0; \n  }\n  \n  .moveLeft {\n    transform: translateX(-300px);\n  }\n\n  .shortMoveLeft {\n    transform: translateX(-150px);\n  }\n  \n  .secondSidebarActive {\n    transform: translateX(0);\n  }\n  \n  /* Adjustments for larger screens */\n  @media (min-width: 768px) {\n    .sidebar {\n      width: 300px; /* Same width as defined for both sidebars */\n    }\n  }\n\n.sideBarInput{\n    width:100%;\n    margin-top: 2rem;\n    margin-bottom: 10px;\n}\n.requiredAsterisk {\n    color: red;\n    margin-left: 4px;\n}\n\n.checkBoxInput {\n    margin-top: 1rem;\n}\n\n.inputTextStyle {\n    width: 100%;\n}\n\n.paymentSidebar {\n    width: 100%;\n}\n\n.productImageWrapper{\n    width: 110px;          /* fixed width */\n    height: 110px;         /* fixed height */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.previewImageWrapper{\n    width: 200px;          /* fixed width */\n    height: 200px;         /* fixed height */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.productImage {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;  /* or cover (see below) */\n}\n\n@media (max-width: 768px) {\n    .productImageWrapper {\n        width: 75px;\n        height: 75px;\n    }\n}\n  \n  @media (min-width: 576px) {\n    .sidebar {\n      width: 75%;\n    }\n    .shotrsidebar {\n        width: 75%;\n      }\n    .sidebarTable {\n        width:75%\n    }\n    .formInput{\n        width: 90%\n    }\n    .paymentSidebar{\n        width: 100%;\n    }\n    .pageSideBar {\n        width: 100%\n    }\n    .moveLeft {\n        transform: translateX(-100%);\n    }\n    .shortMoveLeft {\n    transform: translateX(-100%);\n    }\n  }\n  \n  @media (min-width: 768px) {\n    .sidebar {\n      width: 66.67%;\n    }\n    .shortSideBar{\n        width: 50%;\n    }\n    .sidebarTable {\n        width:75%\n    }\n    .formInput{\n        width: 90%\n    }\n    .paymentSidebar{\n        width: 75%;\n    }\n    .pageSideBar {\n        width: 100%\n    }\n    .moveLeft {\n        transform: translateX(-80%);\n    }\n    .shortMoveLeft {\n    transform: translateX(-70%);\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .sidebar {\n      width: 50%;\n    }\n    .shortSideBar{\n        width: 50%;\n    }\n    .sidebarTable {\n        width:50%\n    }\n    .formInput{\n        width: 90%\n    }\n    .pageSideBar {\n        width: 100%\n    }\n    .paymentSidebar{\n        width: 50%;\n    }\n    .moveLeft {\n        transform: translateX(-80%);\n    }\n    .shortMoveLeft {\n    transform: translateX(-70%);\n    }\n    .currencySpan {\n        padding: 0;\n        width: 60%;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    .sidebar {\n      width: 33.33%;\n    }\n    .shortSideBar{\n        width: 30%;\n    }\n    .sidebarTable {\n        width:50%\n    }\n    .formInput{\n        width: 80%\n    }\n    .pageSideBar {\n        width: 83%\n    }\n    .paymentSidebar{\n        width: 25%;\n    }\n    .moveLeft {\n        transform: translateX(-70%);\n    }\n    .shortMoveLeft {\n    transform: translateX(-50%);\n    }\n    .currencySpan {\n        padding: 0;\n        width: 50%;\n    }\n  }\n \n  @media (min-width: 1700px) {\n    .sidebar {\n      width: 33.33%;\n    }\n    .shortSideBar{\n        width: 25%;\n    }\n    .sidebarTable {\n        width:50%\n    }\n    .formInput{\n        width: 80%\n    }\n    .pageSideBar {\n        width: 83%\n    }\n    .paymentSidebar{\n        width: 20%;\n    }\n    .moveLeft {\n        transform: translateX(-65%);\n    }\n    .shortMoveLeft {\n    transform: translateX(-45%);\n    }\n    .currencySpan {\n        padding: 0;\n        width: 35%;\n    }\n  }\n\n  @media (min-width: 2560px) {\n    .paymentSidebar{\n        width: 15%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullWidth": `CommonStyles_fullWidth__1rJzd`,
	"deleteButton": `CommonStyles_deleteButton__7jZ1N`,
	"deleteButtonNoBackground": `CommonStyles_deleteButtonNoBackground__3JSTF`,
	"editButton": `CommonStyles_editButton__ryC7U`,
	"addButton": `CommonStyles_addButton__zRvfx`,
	"closeButton": `CommonStyles_closeButton__uJHnd`,
	"noStyleButton": `CommonStyles_noStyleButton__r3w6U`,
	"successTag": `CommonStyles_successTag__6YttJ`,
	"warningTag": `CommonStyles_warningTag__+NbMk`,
	"deletedTag": `CommonStyles_deletedTag__UR+lR`,
	"infoTag": `CommonStyles_infoTag__8LRcO`,
	"dialogSubmit": `CommonStyles_dialogSubmit__RKH9b`,
	"dialogFormInput": `CommonStyles_dialogFormInput__Z0hme`,
	"dialogFormInputFirst": `CommonStyles_dialogFormInputFirst__hk6z5`,
	"errorSmall": `CommonStyles_errorSmall__yA+vq`,
	"pseudoFloatLabel": `CommonStyles_pseudoFloatLabel__cMSXp`,
	"smallButton": `CommonStyles_smallButton__EPy+B`,
	"selectSpan": `CommonStyles_selectSpan__rcHE4`,
	"currencySpan": `CommonStyles_currencySpan__0iEbQ`,
	"currencyDropDown": `CommonStyles_currencyDropDown__XR9Mk`,
	"leftMenu": `CommonStyles_leftMenu__TQ3Bi`,
	"mobileActDetailsMenu": `CommonStyles_mobileActDetailsMenu__51V3c`,
	"formInput": `CommonStyles_formInput__SmmwX`,
	"nomargin": `CommonStyles_nomargin__UyNGz`,
	"marginBottom": `CommonStyles_marginBottom__dLtHD`,
	"radioButtonBlock": `CommonStyles_radioButtonBlock__4zblO`,
	"radioButtonBlockWithMarginLeft": `CommonStyles_radioButtonBlockWithMarginLeft__+g6kU`,
	"accountingRadio": `CommonStyles_accountingRadio__8OawM`,
	"active-menu-item": `CommonStyles_active-menu-item__x0YX9`,
	"inputfields": `CommonStyles_inputfields__+d44Z`,
	"inputfieldswomargintop": `CommonStyles_inputfieldswomargintop__shh1z`,
	"smallInput": `CommonStyles_smallInput__eyODV`,
	"p-inputtext": `CommonStyles_p-inputtext__hwAsV`,
	"p-inputnumber-focused": `CommonStyles_p-inputnumber-focused__J93m+`,
	"statusCircle": `CommonStyles_statusCircle__VCTsm`,
	"statusCircleSmall": `CommonStyles_statusCircleSmall__fMyUw`,
	"active": `CommonStyles_active__SsXlU`,
	"pending": `CommonStyles_pending__hBsBD`,
	"inactive": `CommonStyles_inactive__d4nGM`,
	"blankButton": `CommonStyles_blankButton__JDXFi`,
	"listWithButton": `CommonStyles_listWithButton__z4Bui`,
	"sideBarButton": `CommonStyles_sideBarButton__jzqm1`,
	"tableStyle": `CommonStyles_tableStyle__XtI+a`,
	"addButtonNav": `CommonStyles_addButtonNav__ZDWrR`,
	"headerContainer": `CommonStyles_headerContainer__AiZrj`,
	"footerContainer": `CommonStyles_footerContainer__q3dHx`,
	"portraitdiv": `CommonStyles_portraitdiv__bozKt`,
	"portrait": `CommonStyles_portrait__J185z`,
	"orgContent": `CommonStyles_orgContent__jVQDF`,
	"checkboxStyle": `CommonStyles_checkboxStyle__JmI43`,
	"sidebar": `CommonStyles_sidebar__B8-yL`,
	"shortSideBar": `CommonStyles_shortSideBar__s+xB3`,
	"moveLeft": `CommonStyles_moveLeft__vKvXl`,
	"shortMoveLeft": `CommonStyles_shortMoveLeft__k3Nbd`,
	"secondSidebarActive": `CommonStyles_secondSidebarActive__VDTuZ`,
	"sideBarInput": `CommonStyles_sideBarInput__+MnE4`,
	"requiredAsterisk": `CommonStyles_requiredAsterisk__q+9o+`,
	"checkBoxInput": `CommonStyles_checkBoxInput__H2wC3`,
	"inputTextStyle": `CommonStyles_inputTextStyle__yjcHv`,
	"paymentSidebar": `CommonStyles_paymentSidebar__TK-cG`,
	"productImageWrapper": `CommonStyles_productImageWrapper__MnXhK`,
	"previewImageWrapper": `CommonStyles_previewImageWrapper__a7j3d`,
	"productImage": `CommonStyles_productImage__PxNL7`,
	"shotrsidebar": `CommonStyles_shotrsidebar__1O8gZ`,
	"sidebarTable": `CommonStyles_sidebarTable__UlqS9`,
	"pageSideBar": `CommonStyles_pageSideBar__sxTwl`
};
export default ___CSS_LOADER_EXPORT___;
